export default __webpack_public_path__ + "static/media/solucao-07.454de9ce.webp";